class HHBundleVariants extends HTMLElement {
  constructor() {
    super()
    this.mainProduct = this.closest(`#ProductInfo-${this.dataset.section}`)
    this.bundleSelections = new Map()
    this.dropdownButtons = this.querySelectorAll('.vp__dropdown-button')
  }

  connectedCallback() {
    const radioButtons = this.querySelectorAll('input[type="radio"]')
    radioButtons.forEach(radioButton => {
      // Add disabled state to unavailable variants
      const label = radioButton.nextElementSibling.querySelector('.vp__dropdown-swatch')
      if (label.classList.contains('unavailable')) {
        radioButton.disabled = true
      }

      radioButton.addEventListener('change', (event) => {
        // Only process change if the variant is available
        if (!event.target.disabled) {
          this.onVariantChange(event)
          this.updateDropdownSelection(event)
        }
      })
    })
    
    // Add dropdown toggle listeners
    this.dropdownButtons.forEach(button => {
      button.addEventListener('click', () => this.toggleDropdown(button))
    })

    // Close dropdowns when clicking outside
    document.addEventListener('click', (event) => {
      if (!event.target.closest('.vp__dropdown')) {
        this.closeAllDropdowns()
      }
    })
    
    // Initialize bundle selections with first available variants
    this.querySelectorAll('.bundle-variant-picker__item').forEach((item, index) => {
      const variantData = this.getVariantData(item)
      if (variantData && variantData.length > 0) {
        // Find first available variant
        const firstAvailableVariant = variantData.find(variant => variant.available)
        if (firstAvailableVariant) {
          this.bundleSelections.set(index, firstAvailableVariant)
        }
      }
    })
  }

  get disabledUpdateURL() {
    return this.getAttribute('disable-update-url') || false
  }

  onVariantChange(event) {
    // Check if the selected variant is available before proceeding
    const label = event.target.nextElementSibling
    if (label.classList.contains('unavailable')) {
      return
    }

    this.toggleAddButton(false)
    const bundleItem = event.currentTarget.closest('.bundle-variant-picker__item')
    const bundleIndex = Array.from(this.querySelectorAll('.bundle-variant-picker__item')).indexOf(bundleItem)
    
    // Update options for this bundle item
    const options = this.getSelectedOptions(bundleItem)
    const variantData = this.getVariantData(bundleItem)
    
    // Find matching variant
    const selectedVariant = variantData.find((variant) => {
      return !variant.options.map((option, index) => {
        return options[index] === option
      }).includes(false)
    })

    if (selectedVariant && selectedVariant.available) {
      this.bundleSelections.set(bundleIndex, selectedVariant)
      this.updateBundleItemDisplay(bundleItem, selectedVariant)
      this.updateMedia(bundleItem, selectedVariant)
      this.updateVariantInput()
    } 
  }

  getSelectedOptions(bundleItem) {
    const fieldsets = Array.from(bundleItem.querySelectorAll('fieldset'))
    return fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find(
        (radio) => radio.checked
      ).value
    })
  }

  getVariantData(bundleItem) {
    const variantJSON = bundleItem.querySelector('[type="application/json"]')
    return variantJSON ? JSON.parse(variantJSON.textContent) : []
  }

  updateBundleItemDisplay(bundleItem, variant) {
    // Update the "Chosen Variant" text
    const variantTitle = bundleItem.querySelector('.bundle-variant-picker__item-content .vp__input .caption')
    if (variantTitle) {
      variantTitle.textContent = variant.title
    }
  }

  updateVariantInput() {
    const productForm = document.querySelector(`#product-form-${this.dataset.section}`)
    if (!productForm) return

    // Clear any existing bundle inputs
    productForm.querySelectorAll('input[name^="items["]').forEach(input => input.remove())

    // Create inputs for each bundle selection
    Array.from(this.bundleSelections.entries()).forEach(([index, variant]) => {
      // Create ID input
      const idInput = document.createElement('input')
      idInput.type = 'hidden'
      idInput.name = `items[${index}][id]`
      idInput.value = variant.id
      productForm.appendChild(idInput)

      // Create quantity input
      const qtyInput = document.createElement('input')
      qtyInput.type = 'hidden'
      qtyInput.name = `items[${index}][quantity]`
      qtyInput.value = '1'
      productForm.appendChild(qtyInput)
    })
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'))
    if (fieldsets && fieldsets.length) {
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find(
          (radio) => radio.checked
        ).value
      })
    } else {
      this.options = Array.from(
        this.querySelectorAll('select'),
        (select) => select.value
      )
    }
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option
        })
        .includes(false)
    })
  }

  updateMedia(bundleItem, variant) {
    // console.log('updateMedia', bundleItem, variant)
    if (!variant || !variant?.featured_media) return
    
    const itemImage = bundleItem.querySelector('.bundle-variant-picker__item-image')
    console.log('itemImage', itemImage)
    if (!itemImage) return

    // Update the image source if it exists
    if (variant.featured_media.preview_image) {
      itemImage.src = variant.featured_media.preview_image.src.replace('?v', '?width=150&v')
      itemImage.alt = variant.featured_media.alt || variant.title
      // Update srcset for responsive images
      if (variant.featured_media.preview_image) {
        const widths = [150, 300, 450] // Common responsive image widths
        const srcsetValues = widths.map(width => 
          `${variant.featured_media.preview_image.src.replace('?v', `?width=${width}&v`)} ${width}w`
        )
        itemImage.srcset = srcsetValues.join(', ')
      }
    }
  }

  updateURL() {
    if (!this.currentVariant || this.disabledUpdateURL) return
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    )
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability')
    if (!pickUpAvailability) return

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id)
    } else {
      pickUpAvailability.removeAttribute('available')
      pickUpAvailability.innerHTML = ''
    }
  }

  renderProductInfo() {
    let url = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    if (this.dataset.view) {
      url = `${this.dataset.url}?variant=${this.currentVariant.id}&view=${this.dataset.view}`
    }

    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        this._replaceProductInfo(html)
        this.toggleAddButton(
          !this.currentVariant.available,
          html
        )
      })
  }

  _replaceProductInfo(html) {
    const destinations = this.mainProduct.querySelectorAll('[data-render]')
    const sources = html.querySelectorAll('[data-render]')

    destinations.forEach((destination, index) => {
      destination.innerHTML = sources[index]?.innerHTML
      destination.classList.remove('visibility-hidden')
    })
  }

  toggleAddButton(disable = true, html, modifyClass = true) {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]')

    if (!addButton) return

    if (disable) {
      addButton.setAttribute('disabled', true)
    } else {
      addButton.removeAttribute('disabled')
    }

    if (html) {
      const source = html.getElementById(`product-form-${this.dataset.section}`)
        ?.querySelector('[name="add"]')

      if (source && addButton) addButton.innerHTML = source.innerHTML
    }

    if (!modifyClass) return
  }

  setUnavailable() {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]')
    if (!addButton) return
    addButton.textContent = window.variantStrings.unavailable
    document
      .getElementById(`price-${this.dataset.section}`)
      ?.classList.add('visibility-hidden')
  }

  toggleDropdown(button) {
    const isExpanded = button.getAttribute('aria-expanded') === 'true'
    this.closeAllDropdowns()
    
    if (!isExpanded) {
      const content = button.nextElementSibling
      button.setAttribute('aria-expanded', 'true')
      content.hidden = false
    }
  }

  closeAllDropdowns() {
    this.dropdownButtons.forEach(button => {
      button.setAttribute('aria-expanded', 'false')
      const content = button.nextElementSibling
      content.hidden = true
    })
  }

  updateDropdownSelection(event) {
    // Only update if the variant is available
    if (event.target.disabled) {
      return
    }

    const dropdown = event.target.closest('.vp__dropdown')
    const button = dropdown.querySelector('.vp__dropdown-button')
    const selectedLabel = dropdown.querySelector('input:checked + label')
    const selectedSwatch = selectedLabel.querySelector('.vp__dropdown-swatch')
    
    // Update the button content
    const buttonSwatch = button.querySelector('.vp__dropdown-swatch')
    if (buttonSwatch && selectedSwatch) {
      buttonSwatch.style.setProperty('--swatch-background', getComputedStyle(selectedSwatch).getPropertyValue('--swatch-background'))
    }
    
    button.querySelector('.vp__dropdown-selected').textContent = selectedLabel.querySelector('.vp__dropdown-label').textContent
    this.closeAllDropdowns()
  }
}

customElements.define('hh-bundle-variants', HHBundleVariants)
